import React from "react";
import { motion } from "framer-motion";
import Sidebar from "./Sidebar";
import ParticlesBackground from "./ParticlesBackground";

interface LayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
      <ParticlesBackground />

      {/* Background Effects */}
      <div className="absolute inset-0 opacity-20">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="relative z-10">
        <div className="flex min-h-screen">
          <Sidebar />

          <main className="flex-1 p-3 pb-20 sm:p-4 lg:pb-6 lg:p-8">
            {/* Page Header */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="mb-4 sm:mb-6 lg:mb-8"
            >
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">
                {title}
              </h2>
              {subtitle && (
                <p className="text-gray-300 text-sm sm:text-base lg:text-lg">
                  {subtitle}
                </p>
              )}
            </motion.div>

            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
